import layout from '@/views/layout/layout.vue'
const freeAwardInformationList = r => require.ensure([], () => r(require('@/views/marketing/freeAwardInformation/list.vue')), 'group-marketing-freeAwardInformation')

const freeAwardInformationActivity = [
  {
    path: '/marketing/freeAwardInformation',
    name: 'marketing-freeAwardInformation',
    component: layout,
    redirect: '/marketing/freeAwardInformation/list',
    hidden: true,
    children: [
      {
        path: 'list',
        component: freeAwardInformationList,
        name: 'marketing-freeAwardInformation-list',
        meta: {
          displayName: '免费活动管理',
          requireAuth: true
        }
      }
    ]
  }
]

export default freeAwardInformationActivity



// WEBPACK FOOTER //
// ./src/router/marketing/freeAwardInformation.js